import { React, useEffect, useState } from "react";
import {
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import AppButton from "../../../../../base/AppButton.component";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { InputValidation } from "../../../../../../utils/InputValidationRegex";
import { dealerDetails } from "../../../../../../utils/content";
import { DialogStyle } from "./Dialog.styles";
import { useMutation } from "@apollo/client";
import { UPDATE_SUBSCRIPTION } from "../../../../../../graphql/mutation/mutation";

import { useParams } from "react-router-dom";
import { CheckCircle } from "@mui/icons-material";
import { useAuth } from "../../../../../../context/Auth.context";

const UpdateDealershipDialog = (props) => {
  const params = useParams();
  const theme = useTheme();
  const auth = useAuth();
  let { data } = props;
  // const [isSaved, setSaved] = useState(false);
  const [subscription, setSubscription] = useState({
    cost: "0",
    limit: "0",
    overage: "0",
    payload: 1,
    quote_cost: "0",
  });
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [
    updateSubscription,
    { loading: updateLoading, data: updatedSubscription },
  ] = useMutation(UPDATE_SUBSCRIPTION);

  useEffect(() => {
    if (updatedSubscription) {
      // setSaved(true);
      setSubscription({
        cost: "0",
        limit: "0",
        overage: "0",
        payload: 1,
        quote_cost: "0",
      });
      console.log("create", updatedSubscription);
    }
  }, [updatedSubscription]);

  const updateDealerHandler = () => {
    updateSubscription({
      variables: {
        subscriptionInput: {
          dealership_id: parseInt(params.dealershipId),
          cost: parseFloat(subscription.cost),
          limit: parseInt(subscription.limit),
          overage_cost: parseFloat(subscription.overage),
          payload: parseInt(subscription.payload),
          quote_cost: parseFloat(subscription?.quote_cost),
          created_by: auth?.user?.user_id,
          updated_by: auth?.user?.user_id,
        },
      },
    }).then(() => {
      showSuccess();
    });
  };

  useEffect(() => {
    setSubscription({
      cost: data?.cost,
      limit: data?.limit,
      overage: data?.overage_cost,
      payload: data?.payload,
      quote_cost: data?.quote_cost,
    });
  }, [data]);
  const showSuccess = () => {
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 2000);
  };
  return (
    <>
      <Divider />
      <Box sx={{ m: "16px" }}>
        <Box
          sx={{
            ...DialogStyle.emailWidth,
            marginTop: "16px",
          }}
        >
          <FormControl variant="outlined" sx={DialogStyle.formControl}>
            <InputLabel
              color={
                InputValidation.negativeValidation(subscription.cost)
                  ? "error"
                  : "primary"
              }
            >
              Subscription Cost
            </InputLabel>
            <OutlinedInput
              required
              label="Subscription Cost"
              value={subscription.cost}
              type="number"
              error={InputValidation.negativeValidation(subscription.cost)}
              onChange={(event) =>
                setSubscription({
                  ...subscription,
                  cost: event.target.value,
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.negativeValidation(subscription.cost)
                ? "Please enter a valid subscription cost"
                : " "}
            </FormHelperText>
          </FormControl>

          <FormControl variant="outlined" sx={DialogStyle.formControl}>
            <InputLabel
              color={
                InputValidation.negativeValidation(subscription.limit)
                  ? "error"
                  : "primary"
              }
            >
              Max Pull
            </InputLabel>
            <OutlinedInput
              required
              label="Max Pull"
              type="number"
              value={subscription.limit}
              error={InputValidation.negativeValidation(subscription.limit)}
              onChange={(event) =>
                setSubscription({
                  ...subscription,
                  limit: event.target.value,
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.negativeValidation(subscription.limit)
                ? "Please enter a valid max pull"
                : " "}
            </FormHelperText>
          </FormControl>
          <FormControl variant="outlined" sx={DialogStyle.formControl}>
            <InputLabel
              color={
                InputValidation.negativeValidation(subscription?.quote_cost)
                  ? "error"
                  : "primary"
              }
            >
              Request Quote Cost
            </InputLabel>
            <OutlinedInput
              required
              label="Request Quote Cost"
              value={subscription?.quote_cost}
              type="number"
              error={InputValidation.negativeValidation(
                subscription?.quote_cost
              )}
              onChange={(event) =>
                setSubscription({
                  ...subscription,
                  quote_cost: event.target.value,
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.negativeValidation(subscription.quote_cost)
                ? "Please enter a valid quote cost"
                : " "}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box
          sx={{
            ...DialogStyle.emailWidth,
            marginTop: "16px",
          }}
        >
          <FormControl variant="outlined" sx={DialogStyle.formControl}>
            <InputLabel
              color={
                InputValidation.negativeValidation(subscription.overage)
                  ? "error"
                  : "primary"
              }
            >
              Per Pull Overage
            </InputLabel>
            <OutlinedInput
              required
              label=" Per Pull Overage"
              value={subscription.overage}
              error={InputValidation.negativeValidation(subscription.overage)}
              onChange={(event) =>
                setSubscription({
                  ...subscription,
                  overage: event.target.value,
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.negativeValidation(subscription.overage)
                ? "Please enter a valid pull overage"
                : " "}
            </FormHelperText>
          </FormControl>
          <FormControl variant="outlined" sx={DialogStyle.formControl}>
            <InputLabel id="demo-simple-select">Payload</InputLabel>
            <Select
              labelId="demo-simple-select"
              id="demo-simple"
              value={subscription.payload}
              label="Payload"
              onChange={(event) =>
                setSubscription({
                  ...subscription,
                  payload: event.target.value,
                })
              }
            >
              <MenuItem value={1}>Data</MenuItem>
              <MenuItem value={2}>Data & Docs</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      <Box>
        <Box padding={"24px"}>
          <Box sx={DialogStyle.errorIcon} gap="6px">
            <ErrorOutlineOutlinedIcon sx={DialogStyle.error} />
            <Typography variant="caption" color="#C18803">
              The changes will be reflected from start of next month
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider />
      <Box sx={DialogStyle.button}>
        {updatedSubscription?.updateSubscription ? (
          <>
            {showSuccessMessage ? (
              <Box sx={{ display: "flex", my: "14px" }}>
                <CheckCircle color={"primary"} />
                <span
                  style={{
                    color: theme.palette.primary.main,
                    marginLeft: "4px",
                  }}
                >
                  SUCCESS
                </span>
              </Box>
            ) : (
              <AppButton
                buttonText="Update"
                clickHandler={updateDealerHandler}
                size="medium"
                variant="contained"
                sx={{ width: "50%", my: 1 }}
                disabled={updateLoading}
                loading={updateLoading}
              />
            )}
          </>
        ) : (
          <AppButton
            buttonText="Update"
            clickHandler={updateDealerHandler}
            size="medium"
            variant="contained"
            sx={{ width: "50%", my: 1 }}
            disabled={
              subscription.cost === "" ||
              subscription.limit === "" ||
              subscription.overage === "" ||
              subscription?.quote_cost === "" ||
              InputValidation.negativeValidation(subscription.cost) ||
              InputValidation.negativeValidation(subscription.limit) ||
              InputValidation.negativeValidation(subscription.overage) ||
              InputValidation.negativeValidation(subscription?.quote_cost)
            }
            loading={updateLoading}
          />
        )}
      </Box>
    </>
  );
};

export default UpdateDealershipDialog;
